import { render, staticRenderFns } from "./AddIssuerTypes.vue?vue&type=template&id=38213ef3"
import script from "./AddIssuerTypes.vue?vue&type=script&lang=js"
export * from "./AddIssuerTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports